// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { Space } from "@outschool/ui-legacy-component-library";
import { lazyWithRetry } from "@outschool/ui-utils";
import { useRoutes, useTitle } from "@patched/hookrouter";
import React from "react";

import { SearchSuggestionsProvider } from "../../../../shared/client/providers/SearchSuggestionsProvider";
import { HeroLayoutWithTabs } from "../../layout/HeroLayoutWithTabs";
import useAnalyticsPage, {
  PageType,
} from "../../lib/analytics/useAnalyticsPage";
import * as Routes from "../../lib/Routes";
import FindClassesSearchBar from "./SearchBar";

const DefaultPage = lazyWithRetry(() => import("./DefaultPage"));
const KeywordSearchResults = lazyWithRetry(
  () => import("./KeywordSearchResults"),
);
const RecommendedClassesResults = lazyWithRetry(
  () => import("./RecommendedClassesResults"),
);
const TeacherClasses = lazyWithRetry(() => import("./TeacherClasses"));
const TeacherSearchResult = lazyWithRetry(
  () => import("./TeacherSearchResult"),
);
const TopicSearchResults = lazyWithRetry(() => import("./TopicSearchResults"));

type KeywordSearchProps = {
  keyword: string;
};

type TopicSearchProps = {
  topicUid: string;
};

export type SearchProps = KeywordSearchProps | TopicSearchProps;

export function isKeywordSearchProps(
  props: SearchProps,
): props is KeywordSearchProps {
  return props.hasOwnProperty("keyword");
}

function SearchResultsWrapper(props: SearchProps) {
  if (isKeywordSearchProps(props)) {
    return <KeywordSearchResults {...props} />;
  }

  return <TopicSearchResults {...props} />;
}

const searchRoutes = {
  "/": () => <DefaultPage />,
  "/teacher/:leaderLink/classes": ({ leaderLink }: $TSFixMe) => (
    <TeacherClasses leaderLink={leaderLink} />
  ),
  "/teacher/:leaderLink": ({ leaderLink }: $TSFixMe) => (
    <TeacherSearchResult leaderLink={leaderLink} />
  ),
  "/topic/:topicUid": (props: TopicSearchProps) => (
    <SearchResultsWrapper {...props} />
  ),
  "/keyword/": () => <SearchResultsWrapper keyword="" />,
  "/keyword/:keyword": (props: KeywordSearchProps) => (
    <SearchResultsWrapper {...props} />
  ),
  "/recommended": () => <RecommendedClassesResults />,
};

function LearnerFindClasses() {
  useTitle("Find Classes | Outschool");
  useAnalyticsPage({ pageName: PageType.FindClasses });
  // @ts-ignore TS7
  const currentRoute = useRoutes(searchRoutes);

  return (
    <HeroLayoutWithTabs currentPath={Routes.findClassesPath()}>
      <SearchSuggestionsProvider>
        <Space y="medium" />
        <FindClassesSearchBar />
        <Space y="xlarge" />
        {currentRoute}
      </SearchSuggestionsProvider>
    </HeroLayoutWithTabs>
  );
}

export default LearnerFindClasses;
